// ==============================
// Spinner
// ==============================

import spinnerColors from './colors'
import sizes from './sizes'
import { colors } from '@lmc/common/constants'

const theme = {
  spinner: {
    color: {
      danger: '#d64242',
      default: '#CCC',
      inverted: 'white',
      primary: colors.primary,
      success: colors.successgreen,
      warning: '#FA3',
    },
    size: {
      small: 4,
      medium: 8,
      large: 16,
    },
  },
}

// Prepare variants
const colorVariants = {}
spinnerColors.forEach((color) => {
  colorVariants[`color__${color}`] = {
    backgroundColor: theme.spinner.color[color],
  }
})

// Prepare sizes
const sizeVariants = {}
sizes.forEach((size) => {
  sizeVariants[`size__${size}`] = {
    fontSize: theme.spinner.size[size],
  }
})

// Declare animation keyframes
const pulse = {
  '0%, 80%, 100%': { opacity: 0 },
  '40%': { opacity: 1 },
}

export const styles = {
  base: {
    display: 'inline-block',
    lineHeight: 1,
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '5em',
  },
  small: { fontSize: 4 },
  medium: { fontSize: 8 },
  large: { fontSize: 16 },

  // text
  text: {
    border: 0,
    clip: 'rect(0,0,0,0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1,
  },

  // dots
  dot: {
    animationName: pulse,
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    borderRadius: '1em',
    display: 'inline-block',
    height: '1em',
    verticalAlign: 'top',
    width: '1em',
  },
  dot__second: {
    animationDelay: '160ms',
    marginLeft: '1em',
  },
  dot__third: {
    animationDelay: '320ms',
    marginLeft: '1em',
  },

  // Colors
  ...colorVariants,

  // Sizes
  ...sizeVariants,
}

export default styles
